import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { CrntElement } from '../../lib/crnt-element.js';
import { LightDomSlotFallbackController } from '../../lib/light-dom-slot-fallback/light-dom-slot-fallback-controller.js';
import { CrntIconButtonAlt } from '../icon-button-alt/icon-button-alt.component.js';
import { CrntIcon } from '../icon/icon.component.js';
import { CrntTooltipAlternativeDialog } from '../tooltip-alternative-dialog/tooltip-alternative-dialog.component.js';
import { CrntVisuallyHidden } from '../visually-hidden/visually-hidden.component.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class CrntTooltipAlternative extends CrntElement {
  constructor() {
    super(...arguments);
    this.closeButtonLabel = "Close";
    this.dialogTitle = null;
    this.toggleButtonIcon = "info-circle";
    this.toggleButtonLabel = null;
    this._lightDomSlotFallbackController = new LightDomSlotFallbackController(
      this,
      this._lightDomSlotFallbackControllerSlots
    );
  }
  static {
    this.dependencies = {
      [CrntIcon.tagName]: CrntIcon,
      [CrntIconButtonAlt.tagName]: CrntIconButtonAlt,
      [CrntTooltipAlternativeDialog.tagName]: CrntTooltipAlternativeDialog,
      [CrntVisuallyHidden.tagName]: CrntVisuallyHidden
    };
  }
  static {
    this.tagName = "crnt-tooltip-alternative";
  }
  get _lightDomSlotFallbackControllerSlots() {
    return [
      () => ({
        fallbackElement: () => {
          if (this.toggleButtonLabel) {
            const iconButton = document.createElement(CrntIconButtonAlt.tagName);
            const button = document.createElement("button");
            const icon = document.createElement(CrntIcon.tagName);
            const visuallyHidden = document.createElement(CrntVisuallyHidden.tagName);
            iconButton.variant = "ui";
            button.type = "button";
            icon.icon = this.toggleButtonIcon;
            visuallyHidden.innerText = this.toggleButtonLabel;
            button.appendChild(icon);
            button.appendChild(visuallyHidden);
            iconButton.appendChild(button);
            return iconButton;
          }
          const errorMessage = document.createElement("span");
          errorMessage.innerText = "Provide a toggleButtonLabel";
          return errorMessage;
        },
        override: true,
        slotName: "_toggle-button"
      }),
      () => ({
        fallbackElement: () => {
          const dialog = document.createElement(CrntTooltipAlternativeDialog.tagName);
          if (this.dialogTitle) {
            const titleSlot = document.createElement("span");
            titleSlot.slot = "title";
            titleSlot.innerText = this.dialogTitle;
            dialog.appendChild(titleSlot);
          }
          if (this.closeButtonLabel) {
            const closeButtonLabelSlot = document.createElement("span");
            closeButtonLabelSlot.slot = "close-button-label";
            closeButtonLabelSlot.innerText = this.closeButtonLabel;
            dialog.appendChild(closeButtonLabelSlot);
          }
          const defaultSlottedElements = this.shadowRoot?.querySelector("slot:not([name])")?.assignedElements();
          if (defaultSlottedElements && defaultSlottedElements.length > 0) {
            defaultSlottedElements.forEach((el) => {
              const clone = el.cloneNode(true);
              dialog.appendChild(clone);
            });
          }
          return dialog;
        },
        override: true,
        slotName: "_dialog"
      })
    ];
  }
  close() {
    this.querySelector(CrntTooltipAlternativeDialog.tagName)?.close();
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("click", this._handleClick.bind(this));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("click", this._handleClick.bind(this));
  }
  render() {
    return html`
			<slot name="_toggle-button"></slot>
			<slot name="_dialog"></slot>
			<slot hidden @slotchange="${this._handleSlotChange}"></slot>
		`;
  }
  showModal() {
    this.querySelector(CrntTooltipAlternativeDialog.tagName)?.showModal();
  }
  willUpdate(changedProperties) {
    super.willUpdate(changedProperties);
    if (["icon", "toggleButtonLabel", "dialogTitle", "closeButtonLabel", "toggleButtonIcon"].some(
      (attr) => changedProperties.has(attr)
    )) {
      this._lightDomSlotFallbackController.setFallbackSlotsContent();
    }
  }
  _handleClick(event) {
    const toggleButton = this.querySelector('[slot="_toggle-button"] button');
    if (event.target.isEqualNode(toggleButton)) {
      this.showModal();
    }
  }
  _handleSlotChange() {
    this._lightDomSlotFallbackController.setFallbackSlotsContent();
  }
}
__decorateClass([
  property({ attribute: "close-button-label" })
], CrntTooltipAlternative.prototype, "closeButtonLabel");
__decorateClass([
  property({ attribute: "dialog-title" })
], CrntTooltipAlternative.prototype, "dialogTitle");
__decorateClass([
  property({ attribute: "toggle-button-icon" })
], CrntTooltipAlternative.prototype, "toggleButtonIcon");
__decorateClass([
  property({ attribute: "toggle-button-label" })
], CrntTooltipAlternative.prototype, "toggleButtonLabel");

export { CrntTooltipAlternative };
